import React, { useEffect } from 'react'
import { Container, Grid, Box, } from '@mui/material';
import Buyright from './Buyright';
import Buyleft from './Buyleft';
import axios from 'axios';
import { useState } from 'react';
import { API_URL } from '../../Config';
import { useParams } from 'react-router-dom';

const Buydetails = () => {
    const [buydata,setbuydata]= useState([]);
    const {id} =useParams();

    const fetchBuydata=async()=>{
        let data =await axios.get(`${API_URL}/buyItem.php?id=${id}`,{
            headers:{
                "Content-Type":"application/json",
            },
    
         })

        await setbuydata(data); 
    }
    useEffect(()=>{
       fetchBuydata();
    },[])
    return (
        <>
            <Box>
                <Container maxWidth='xl'>
                    <Grid container className='contracts'>
                        <Grid item lg={6} sm={12} md={6} xs={12}>
                            <Buyright buyprop={buydata && buydata} />
                        </Grid>
                        <Grid item lg={6} sm={12} md={6} xs={12}>
                            <Buyleft buyprop={buydata && buydata} />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    )
}

export default Buydetails;